import { render } from "./Content_edit.vue?vue&type=template&id=6e5386f9&scoped=true"
import script from "./Content_edit.vue?vue&type=script&lang=js"
export * from "./Content_edit.vue?vue&type=script&lang=js"

import "./Content_edit.vue?vue&type=style&index=0&id=6e5386f9&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5386f9"]])

export default __exports__